<template>
  <v-container grid-list-xl>
    <v-layout wrap>

<v-dialog v-model="loading" fullscreen full-width>
  <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
    <v-layout justify-center align-center>
      <v-progress-circular
        indeterminate
        color="primary">
      </v-progress-circular>
    </v-layout>
  </v-container>
</v-dialog>

<v-flex>
  <v-alert type="error" dismissible v-model="alert">
    {{ error }}
  </v-alert>
</v-flex>

      <v-flex xs12 class="text-center">
        <h1>Sign Up</h1>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3>
        <form @submit.prevent="userSignUp">
          <v-layout column>
            <v-flex>
              <v-text-field
                name="email"
                label="Email"
                id="email"
                type="email"
                v-model="email"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="password"
                label="Password"
                id="password"
                type="password"
                v-model="password"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="confirmPassword"
                label="Confirm Password"
                id="confirmPassword"
                type="password"
                v-model="passwordConfirm"
                required
                :rules="[comparePasswords]"
                ></v-text-field>
            </v-flex>

            <v-flex>
              <v-text-field
                name="first_name"
                label="First name"
                id="first_name"
                type="text"
                v-model="first_name"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="last_name"
                label="Last Name"
                id="last_name"
                type="text"
                v-model="last_name"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="title"
                label="Title"
                id="title"
                type="text"
                v-model="title"
               ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="company"
                label="Company"
                id="company"
                type="text"
                v-model="company"
               ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="phone"
                label="Phone number"
                id="phone"
                type="phone"
                v-model="phone"
                required></v-text-field>
            </v-flex>

            <v-flex class="text-center">
              <v-btn color="primary" type="submit" :disabled="loading">Sign Up</v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      passwordConfirm: '',
      first_name: '',
      last_name: '',
      title: '',
      company: '',
      phone: '',
      alert: false
    }
  },
  computed: {
    comparePasswords () {

      return this.password === this.passwordConfirm ? true : 'Passwords don\'t match'
    },
    error () {
      return this.$store.state.error
    },
    loading () {
      return this.$store.state.loading
    }
  },
  methods: {
    userSignUp () {
      if (this.comparePasswords !== true) {
        return
      }
      this.$store.dispatch('userSignUp', { 
        email: this.email,
        password: this.password,
        first_name: this.first_name,
        last_name: this.last_name,
        title: this.title,
        company: this.company,
        phone: this.phone })
    }
  },
  watch: {
    error (value) {
      if (value) {
        this.alert = true
      }
    },
    alert (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    }
  }
}
</script>